import ValidService from "../../../service/ValidService";
let model = {};

model.dataForm = {
    id: null, // optional
    tieu_de: null, // optional Tiêu đề giới thiệu
    anh_hien_thi: null, // optional Ảnh hiển thị của giới thiệu
    noi_dung: [], // optional Nội dung của giới thiệu
    ngon_ngu: "vi"
}

model.dataFormNoiDung = {
    id: null, // optional Ảnh hiển thị của nội dung
    noi_dung: null, // optional Nội dung hiển thị
    img: []
}

model.dataFormOther = {
    fileUploadOption: {
        AnhGioiThieu: {
            limit: 100,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhIconGioiThieu: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false
        }
    },
};


model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: false,
    allowSorting: false,
    allowSelect: false,
    showFormSearch: false,
    showUrl: false,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {},
        valid: {},
        operator: {}
    }
};

export default model;
